import * as apiFunction from '@services/apiFunctions'

import { API_URLS } from '@services/apiRoutes'

export const getSideBarData = async () => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.auth.getSideBarData}`,
    method: 'GET'
  })
}
